import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import classNames from 'classnames';
import SectionWrapper from 'ferries/Home/components/SectionWrapper';
import Section from 'helpers/Section';
import {replaceAssetsImgUrl} from 'cms/helpers/common';
import {MOBILE_WIDTH, TABLET_WIDTH} from 'helpers/stableValues';

const sliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: true,
  responsive: [{
    breakpoint: TABLET_WIDTH,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: MOBILE_WIDTH,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};

const Destinations = ({destinations}) => {
  const {title, subtitle, description, items} = destinations;
  const itemsLength = items.length - 1;

  return (
    <>
      <SectionWrapper title={title} subtitle={subtitle} description={description} bgColor="bg-primary-light">
        <br/><br/><br/><br/><br/><br/>
      </SectionWrapper>
      <div className="mb-4" style={{marginTop: '-200px'}}>
        <Section>
          <Slider {...sliderSettings}>
            {
              items.map(({ID, post_title, permanlink, image, country}, index) => {
                const itemClass = classNames('text-center', {
                  'px-2': index !== 0 && index !== itemsLength,
                  'pl-2': index === itemsLength,
                  'pr-2': index === 0
                });

                return (
                  <div key={ID ?? post_title} className={itemClass}>
                    <a
                      href={permanlink}
                      target="_blank"
                      rel="noreferrer"
                      className="position-relative text-decoration-none bg-cover d-block rounded"
                      style={{height: '200px'}}
                    >
                      <img
                        className="position-absolute w-1-1 h-1-1 img-cover"
                        src={replaceAssetsImgUrl(image, 400)}
                      />
                      <div
                        className="position-relative bg-overlay w-1-1 h-1-1 text-white d-flex
                          justify-content-center align-items-center text-center rounded"
                      >
                        <div>
                          <div className="text-lead"><b>{post_title}</b></div>
                          <div className="mini-rectangle-line bg-accent mx-auto my-1" />
                          {country && <div>{country}</div>}
                        </div>
                      </div>
                    </a>
                  </div>
                );
              })
            }
          </Slider>
        </Section>
      </div>
    </>
  );
};

Destinations.propTypes = {
  destinations: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    destinationsUrl: PropTypes.string,
    items: PropTypes.array.isRequired
  })
};

export default Destinations;
